import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const initialState = {
  compareProductIds: JSON.parse(Cookies.get("compareProductIds") || "[]"),
  compareProducts: [],
};

const compareSlice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    addToCompare: (state, action) => {
      const productId = action.payload;
      // Add product to the compare list if it's not already in the list
      if (
        state.compareProductIds.length < 4 &&
        !state.compareProductIds.includes(productId)
      ) {
        state.compareProductIds.push(productId);
        Cookies.set(
          "compareProductIds",
          JSON.stringify(state.compareProductIds),
          { expires: 30 }
        );
      } else {
        toast.success("You can only compare up to 4 products.");
      }
    },

    removeFromCompare: (state, action) => {
      const productId = action.payload;
      state.compareProductIds = state.compareProductIds.filter(
        (id) => id !== productId
      );
      Cookies.set(
        "compareProductIds",
        JSON.stringify(state.compareProductIds),
        { expires: 30 }
      );
    },

    initializeCompareProductIds: (state) => {
      const compareProductIdsFromCookie = JSON.parse(
        Cookies.get("compareProductIds") || "[]"
      );
      state.compareProductIds = compareProductIdsFromCookie;
    },

    setCompareProducts: (state, action) => {
      state.compareProducts = action.payload;
    },
  },
});

export const {
  addToCompare,
  removeFromCompare,
  initializeCompareProductIds,
  setCompareProducts,
} = compareSlice.actions;

export default compareSlice.reducer;
